module.exports = __webpack_public_path__ + "assets/img/29.c8194ad6.png";